export class CensusSnapshot {
  shiftBlockId: number;
  shiftRecordId?: number;
  costCenterId: number;
  workflowTimeFacility: string;
  admits: number;
  transfersIn: number;
  transfersOut: number;
  discharges: number;
  isProjected: boolean;
  modifiedByUserName: string;
  modifiedDate: Date;
}
